import Node from "@/pages/Node/index.vue";
import auth from "../middleware/authMiddleware.js";
import meta from "../middleware/metaMiddleware.js";
import canNode from "../middleware/canNodeMiddleware.js";

export default [
  {
    path: "/node/:id",
    name: "Node",
    component: Node,
    meta: {
      middleware: [auth, meta, canNode]
    },
    props: true
  },
  {
    path: "/node/:id/from/:pid",
    name: "NodeWithParentSpec",
    component: Node,
    meta: {
      middleware: [auth, meta, canNode]
    },
    props: true
  },
  {
    path: "/node/:id/contents",
    name: "NodeChildren",
    component: Node,
    meta: {
      middleware: [auth, meta, canNode]
    },
    props: true
  },
  {
    path: "/node/:id/add/:classAdd",
    name: "NodeAdd",
    component: Node,
    meta: {
      middleware: [auth, meta, canNode]
    },
    props: true
  }
];
